import React from "react";
import * as moment from "moment";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import PropTypes from "prop-types";

export default function FormattedDate(props) {
    if(props.value || props.skeleton === undefined)
    {
        const formattedValue = moment(props.value, props.inputFormat || null).format(props.outputFormat|| "DD/MM/YYYY");
        return <React.Fragment>{formattedValue}</React.Fragment>
    }
    else
    {
        return (
            <SkeletonTheme color="#0071b9" highlightColor="#8ebcd2" >
                <Skeleton />
            </SkeletonTheme>
        )
    }
};

FormattedDate.propTypes = {
    value: PropTypes.any.isRequired,
    skeleton: PropTypes.bool,
    inputFormat: PropTypes.string,
    outputFormat: PropTypes.string,
};